import React from "react"
import PropTypes from "prop-types"
import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
} from "react-share"

import { Button } from "semantic-ui-react"

const ShareHeader = ({ socialConfig, tags }) => (
  <>
    <FacebookShareButton url={socialConfig.config.url}>
      <Button circular color="facebook" icon="facebook" />
    </FacebookShareButton>
    <TwitterShareButton
      url={socialConfig.config.url}
      title={socialConfig.config.title}
      via={socialConfig.twitterHandle.split("@").join("")}
      hashtags={tags}
    >
      <Button circular color="twitter" icon="twitter" />
    </TwitterShareButton>
    <LinkedinShareButton url={socialConfig.config.url}>
      <Button circular color="linkedin" icon="linkedin" />
    </LinkedinShareButton>
    <RedditShareButton
      url={socialConfig.config.url}
      className="button is-outlined is-rounded reddit"
      title={socialConfig.config.title}
    >
      <Button circular color="orange" icon="reddit" />
    </RedditShareButton>
  </>
)

ShareHeader.propTypes = {
  socialConfig: PropTypes.shape({
    twitterHandle: PropTypes.string.isRequired,
    config: PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
}

ShareHeader.defaultProps = {
  tags: [],
}

export default ShareHeader
